import "./styles.scss";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import Button from "components/Button";
import Loader from "components/Loader";
import IconButton from "components/IconButton";

import { ReactComponent as CrossIcon } from "assets/icons/modal-cross.svg";

const mainClass = "modal";

const Modal = ({
  children,
  title,
  description,
  variant,
  mode,
  loading,
  submit_button_label = "Update data",
  hide_submit_button,
  data_loading,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const onCloseHandler = () => {
    setOpen(false);

    onClose();
  };

  return createPortal(
    <div
      className={classnames(mainClass, {
        [`${mainClass}--${variant}`]: !!variant,
        [`${mainClass}--${mode}`]: !!mode,
        [`${mainClass}--open`]: !!open,
      })}
    >
      <div className={`${mainClass}__container`}>
        <div className={`${mainClass}__wrapper`}>
          {!!title && (
            <div className={`${mainClass}__header`}>
              <h3>{title}</h3>
              {!!description && <p>{description}</p>}
              <IconButton
                variant="medium"
                onClick={onCloseHandler}
                icon={<CrossIcon />}
              />
            </div>
          )}
          <div className={`${mainClass}__content`}>
            {!!!data_loading ? children : <Loader color="blue" size="large" />}
          </div>
          {!!!hide_submit_button && (
            <div className={`${mainClass}__action`}>
              {!!!hide_submit_button && (
                <Button size="small" onClick={onSubmit} loading={loading}>
                  {t(submit_button_label)}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
      <div
        className={`${mainClass}__backdrop`}
        // onClick={!!isMobile ? onCloseHandler : onClose}
        onClick={onClose}
      ></div>
    </div>,
    document.body,
  );
};

export default Modal;
